import { Component, Input } from '@angular/core';

import { AirportNavaid } from '../models/airport-navaid.model';


@Component({
  selector: 'app-navaid-listing',
  templateUrl: './navaid-listing.component.html',
  styleUrls: ['./navaid-listing.component.scss']
})
export class NavaidListingComponent {
  @Input() navaids: Array<AirportNavaid>;
  @Input() identifier: string;

  get sortedNavaids(): Array<AirportNavaid> {
    return (this.navaids || []).sort((n1, n2) => n1.distance - n2.distance);
  }

  onNavaidDeleted(navaidId) {
    const index = this.navaids.findIndex(n => n.navaidId === navaidId);
    if (index > -1) {
      this.navaids.splice(index, 1);
    }
  }
}
